import { Controller } from 'stimulus';
import { renderBarChart } from '../packs/vega_chart_helpers';

export default class extends Controller {
  connect() {
    let controller = this;
    this.element.querySelectorAll(".stats-component").forEach(elem => {
      controller.renderChart(elem);
    });
  }

  renderChart(elem) {
    let type = elem.dataset.type;
    let params = `?type=${type}`

    Rails.ajax({
      type: 'GET',
      url: `/superadmin/organizations/${elem.dataset.orgId}/charts_data${params}`,
      dataType: 'json',
      success: (response) => {
        $(elem).find(".spinner-div").hide();

        if(type == "logins_per_day"){
          renderBarChart(`.logins_per_day_${elem.dataset.orgId}`, response.data, {x: 'Date', y: "Login Count"})
        } else if(type == "active_users_per_day"){
          renderBarChart(`.active_users_per_day_${elem.dataset.orgId}`, response.data, {x: 'Date', y: "Active Users"})
        }

      }
    });

  }
}